module.exports = __webpack_public_path__ + "img/7bb6373.svg";